import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=5d3a3ef8&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"
import style0 from "./pie.vue?vue&type=style&index=0&id=5d3a3ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a3ef8",
  null
  
)

export default component.exports